import { useController, UseControllerProps } from 'react-hook-form';

import {
  FormControl,
  FormHelperText,
  Switch as MaterialSwitch,
  SwitchProps,
  Typography,
} from '@mui/material';
import { Stack } from '@mui/system';

interface Props extends SwitchProps, UseControllerProps {
  name: string;
  defaultValue?: any;
  label?: string;
  leftlabel?: string;
  rightLabel?: string;
  leftValue?: any;
  rightValue?: any;
}

export const SwitchDoubleValue: React.FC<Props> = ({
  name,
  rules,
  shouldUnregister,
  defaultValue,
  control,
  label,
  leftlabel,
  rightLabel,
  leftValue,
  rightValue,
  ...props
}) => {
  const { field, fieldState } = useController({
    name,
    rules,
    shouldUnregister,
    defaultValue,
    control,
  });

  return (
    <FormControl error={Boolean(fieldState.error?.message)}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography
          fontSize={16}
          fontWeight={500}
          color={field.value === leftValue ? '#000' : '#00000059'}
        >
          {leftlabel}
        </Typography>

        <MaterialSwitch
          inputProps={{ 'aria-label': 'controlled' }}
          onBlur={field.onBlur}
          checked={field.value === rightValue}
          onChange={(_, value) => {
            if (value) {
              field.onChange(rightValue);
            } else {
              field.onChange(leftValue);
            }
          }}
          {...props}
        />

        <Typography
          fontSize={16}
          fontWeight={500}
          color={field.value === rightValue ? '#000' : '#00000059'}
        >
          {rightLabel}
        </Typography>
      </Stack>
      <FormHelperText>{fieldState.error?.message}</FormHelperText>
    </FormControl>
  );
};
